// extracted by mini-css-extract-plugin
export default {"NavigationIcon":"NavigationIcon_NavigationIcon__SkGD2","isSelected":"NavigationIcon_isSelected__gSwvw"};